import {connect} from "react-redux"
import {createSelector} from "reselect"
import {clearFilters, setFacetsModal} from "../../ducks/viewAllModal"
import State from "../../models/State"
import TrackViewAllModalRemoveAll from "../../events/trackEvent/events/viewAllModalRemoveAll"

// Selector for facets
const selectViewAllModalFacets = (state: State) => state.viewAllModal.facets

// Memoized selector for selectedFacets
const makeSelectSelectedFacets = createSelector([selectViewAllModalFacets], facets =>
    Object.values(facets).filter(filter => filter.s),
)

export const mapStateToProps = (state: State) => {
    const {text} = state
    const title = state.viewAllModal.displayName
    return {
        title,
        selectedFacets: makeSelectSelectedFacets(state),
        text,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    onClearFacets: (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        dispatch(clearFilters())
        TrackViewAllModalRemoveAll()
    },

    selectFacet: (facetValue: string): void => {
        dispatch(setFacetsModal(facetValue))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
